import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function BeginnerSection() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const lang = location.pathname.split('/')[1];
  const currentLang = ['en', 'pt', 'de'].includes(lang) ? lang : 'en';

  const steps = [
    { num: '01', text: 'beginner.step1' },
    { num: '02', text: 'beginner.step2' },
    { num: '03', text: 'beginner.step3' },
    { num: '04', text: 'beginner.step4' },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
              {t('beginner.h2')}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-10">
            {steps.map((step, i) => (
              <div key={i} className="relative p-6 bg-background-100 rounded-xl border border-background-200">
                <span className="text-3xl font-bold text-primary-200 font-heading">{step.num}</span>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{t(step.text)}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a
              href={`/${currentLang}/articles/cssbuy-spreadsheet-guide`}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              {t('beginner.cta')}
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}